import { ComponentProps } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { DetailsItemsList } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

interface QuotePrincingFinancialSumaryProps {
  totalHours: string
  estimatedCosts: string
  subtotal: string
  total: string
}
const QuotePrincingFinancialSumary = ({
  totalHours,
  estimatedCosts,
  subtotal,
  total,
}: QuotePrincingFinancialSumaryProps) => {
  const hoursAndCostsDetails: ComponentProps<typeof DetailsItemsList>['details'] = [
    {
      title: i18n.t('finance.quotes.quote_phases_table.sumary.total_hours'),
      content: {
        type: 'item',
        text: totalHours,
      },
    },
    {
      title: i18n.t('finance.quotes.quote_phases_table.sumary.estimated_costs'),
      content: {
        type: 'item',
        text: estimatedCosts,
      },
    },
  ]

  const TotalDetails: ComponentProps<typeof DetailsItemsList>['details'] = [
    {
      title: i18n.t('finance.quotes.quote_phases_table.sumary.subtotal'),
      content: {
        type: 'item',
        text: subtotal,
      },
    },
    {
      title: i18n.t('finance.quotes.quote_phases_table.sumary.total'),
      content: {
        type: 'item',
        text: total,
      },
    },
  ]
  return (
    <Box flexDirection="column" gap="s16">
      <DetailsItemsList
        details={hoursAndCostsDetails}
        tableView
        title={i18n.t('finance.quotes.quote_phases_table.sumary.title')}
      />
      <DetailsItemsList details={TotalDetails} tableView />
    </Box>
  )
}

export default QuotePrincingFinancialSumary
